import { Box, Typography } from '@mui/material';
import { formatDollarAmount } from '../../utils/global/helper';
import TransactionBadge from './TransactionBadge';
import {
  convertPaymentsToTransactions,
  getPaymentAmountWithoutServiceFee,
} from '../../helpers/payments';
import { PaymentsGroup } from '../../types/payments';

interface Props {
  group: PaymentsGroup;
}

export default function AmountSection({ group }: Props) {
  const { payments } = group;

  const amountFromPayments = payments.reduce(
    (acc, payment) => acc + getPaymentAmountWithoutServiceFee(payment),
    0,
  );

  const payment = payments.find(p => p.method !== 'GIFT_CARD') || payments[0];
  const [transaction] = convertPaymentsToTransactions([payment]);

  const isPaymentRefunded = payments?.some(p => p.status === 'REFUNDED');
  const isFailed = payments?.some(
    p => p.status === 'FAILED' || (p.status === 'PENDING' && !!payment.error),
  );

  return (
    <Box
      gap={0.5}
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}>
      <Typography variant="body1" sx={{ minWidth: '80px' }}>
        {formatDollarAmount(amountFromPayments)}
      </Typography>
      <TransactionBadge
        status={
          isPaymentRefunded ? 'REFUNDED' : isFailed ? 'FAILED' : undefined
        }
        transaction={transaction}
      />
    </Box>
  );
}
